import { FileText, FileStack } from 'lucide-react';

// Phase 4: bundle-vs-per-document mode selector shown at the top of both e-sign modals.
// Selecting the other mode swaps the open modal (parent controls which one renders).
export function EsignModeTabs({ mode, onSelect }) {
  const Item = ({ value, icon: Icon, title, desc, testid }) => (
    <button
      type="button"
      onClick={() => mode !== value && onSelect(value)}
      data-testid={testid}
      className={`flex-1 text-left rounded-lg border p-3 transition-colors ${
        mode === value
          ? 'border-blue-600 bg-blue-50/60 ring-1 ring-blue-600'
          : 'border-slate-200 bg-white hover:border-slate-300'
      }`}
    >
      <div className="flex items-center gap-2 font-medium text-sm">
        <Icon className="w-4 h-4" /> {title}
        {mode === value && <span className="ml-auto text-[10px] uppercase tracking-wide text-blue-700 font-semibold">Selected</span>}
      </div>
      <p className="text-xs text-slate-500 mt-1">{desc}</p>
    </button>
  );
  return (
    <div className="flex gap-3" data-testid="esign-mode-tabs">
      <Item
        value="per_document"
        icon={FileText}
        title="Per Document"
        desc="Each document is signed separately with its own signatories."
        testid="esign-mode-per-document"
      />
      <Item
        value="bundle"
        icon={FileStack}
        title="Single Bundle"
        desc="Documents are merged into one PDF (request form as cover pages) and signed once."
        testid="esign-mode-bundle"
      />
    </div>
  );
}

export default EsignModeTabs;
